import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusDoneFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.3277 8.51801L9.47933 12.3663C9.35683 12.4888 9.19766 12.5497 9.03766 12.5497C8.87683 12.5497 8.71766 12.4888 8.59516 12.3663L6.671 10.4422C6.42683 10.198 6.42683 9.80217 6.671 9.55801C6.91516 9.31384 7.31016 9.31384 7.55433 9.55801L9.03766 11.0405L12.4435 7.63384C12.6877 7.38967 13.0835 7.38967 13.3277 7.63384C13.5718 7.87801 13.5718 8.27384 13.3277 8.51801ZM10.0002 2.08301C5.63516 2.08301 2.0835 5.63467 2.0835 9.99967C2.0835 14.3655 5.63516 17.9163 10.0002 17.9163C14.3652 17.9163 17.9168 14.3655 17.9168 9.99967C17.9168 5.63467 14.3652 2.08301 10.0002 2.08301Z"
	})
});
export default SvgMemberStatusDoneFill;
